// extracted by mini-css-extract-plugin
export var noSpinners = "_s9-6";
export var percentageInput = "_s9-7";
export var variantColor1 = "_s9-0";
export var variantColor2 = "_s9-1";
export var variantColor3 = "_s9-2";
export var variantColor4 = "_s9-3";
export var variantColor5 = "_s9-4";
export var variantColor6 = "_s9-5";